var React = require('react');

function Relic (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("polygon",{"points":"8,19 -0.1,10.9 8,2.8 9.5,4.2 2.8,10.9 9.5,17.6 ","key":1}),React.createElement("rect",{"x":"1","y":"10","width":"15","height":"2","key":2}),React.createElement("polygon",{"points":"19.7,25 18.3,23.6 25,16.9 18.3,10.2 19.7,8.8 27.8,16.9 ","key":3}),React.createElement("rect",{"x":"12","y":"16","width":"15","height":"2","key":4})]);
}

Relic.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 28 28","style":{"enableBackground":"new 0 0 28 28"},"xmlSpace":"preserve"};

module.exports = Relic;

Relic.default = Relic;
